import './PorqueElegirnos.css';
import { Link } from 'react-router-dom';

export default function PorqueElegirnos() {
  return (
    <section className="porque">

      <div className="porque-header">
        <h2>¿Por qué elegirnos?</h2>
        <p>
          Somos aliados estratégicos en soluciones de empaque, combinando calidad,
          sostenibilidad e innovación para impulsar el crecimiento de nuestros clientes.
        </p>
      </div>

      <div className="porque-grid">

        <div className="porque-card">
          <h3>Alta calidad</h3>
          <p>Procesos productivos certificados que garantizan resultados confiables.</p>
        </div>

        <div className="porque-card">
          <h3>Sostenibilidad</h3>
          <p>Comprometidos con el medio ambiente y la economía circular.</p>
        </div>

        <div className="porque-card">
          <h3>Experiencia</h3>
          <p>Años de trayectoria en el sector industrial respaldan nuestro trabajo.</p>
        </div>

        <div className="porque-card">
          <h3>Cobertura</h3>
          <p>Atendemos clientes a nivel nacional e internacional con soluciones eficientes.</p>
        </div>

      </div>

      {/* 🔥 CTA */}
      <div className="porque-cta">
        <Link to="/contacto" className="btn-contacto">
          Contáctanos
        </Link>
      </div>

    </section>
  );
}